import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g fill={props.fill || 'white'} stroke={props.stroke || '#070F21'}>
      <path d="M12.461 16.727a1.26 1.26 0 0 0 1.13-1.179c.131-2.121.201-4.189.201-6.548 0-2.36-.07-4.427-.2-6.548a1.26 1.26 0 0 0-1.131-1.179 48.813 48.813 0 0 0-10.166 0 1.26 1.26 0 0 0-1.13 1.179C1.034 4.573.965 6.64.965 9c0 2.36.069 4.427.2 6.548a1.26 1.26 0 0 0 1.13 1.179c3.535.354 6.632.354 10.166 0ZM13.792 2.584h1.886c.439 0 .862.217 1.043.617.461 1.02.393 1.991-.056 3.49a1.247 1.247 0 0 1-1.203.876h-1.67V2.584Z" />
      <path d="M13.792 7.567h1.886c.439 0 .862.218 1.043.618.461 1.019.393 1.99-.056 3.49a1.247 1.247 0 0 1-1.203.876h-1.67V7.567ZM9.225 4.423H5.53a.964.964 0 0 0-.964.964v1.299c0 .532.431.964.964.964h3.695a.964.964 0 0 0 .964-.964V5.387a.964.964 0 0 0-.964-.964Z" />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const BlogSidebarIcon = memo(ForwardRef);
export default BlogSidebarIcon;
